let moment: any = require("moment")
const BACKEND_DATE_FORMAT: string = "YYYY-MM-DDTHH:mm:00";

export class FilterListService {

	private static determinePastEventsBeginDate(): string {
		let fiveDaysAgo = moment().subtract(5, "days").startOf("day")
		return fiveDaysAgo.format(BACKEND_DATE_FORMAT)
	}

	public filterString(input: any, property: string, filter: string) {
		let filteredList: any = []
		let filtered: any = []
		if (input) {
			if (filter) {
				filtered = input.filter(item => {
					filter = filter.toLowerCase();
					let match = false;
					if (item[property] && item[property].toString().toLowerCase().indexOf(filter) > -1) {
						match = true;
					}
					return match;
				});
				filteredList = filtered;
			} else {
				filteredList = input
			}
		}
		return filteredList;
	}

	public filterMinMaxDate(input: any, propertyBegin: string, propertyEnd: string, minDateString: string, maxDateString: string) {
		let filteredList: any = []
		let filtered: any = []

		if (input) {
			if ((minDateString) && (!maxDateString)) {
				filtered = input.filter(item => {
					let match = false;
					if (moment(item[propertyBegin]).isSameOrAfter(minDateString)) {
						match = true;
					}
					return match;
				});
			} else if ((!minDateString) && (maxDateString)) {
				filtered = input.filter(item => {
					let match = false;
					if ((!item[propertyEnd]) || (moment(item[propertyEnd]).isSameOrBefore(maxDateString))) {
						match = true;
					}
					return match;
				});

			} else if ((minDateString) && (maxDateString)) {
				filtered = input.filter(item => {
					let match = false;
					if ((moment(item[propertyBegin]).isSameOrAfter(minDateString))
						&&
						((!item[propertyEnd]) || (moment(item[propertyEnd]).isSameOrBefore(maxDateString)))) {
						match = true;
					}
					return match;
				});

			} else {
				filtered = input
			}
			filteredList = filtered;
		}
		return filteredList;
	}

	public filterPastEvents(input: any, propertyBegin: string, propertyEnd: string) {
		let pastDate = FilterListService.determinePastEventsBeginDate()
		return input.filter(item => {
			let match = false;
			if (moment(item[propertyEnd] ? item[propertyEnd] : item[propertyBegin]).isSameOrAfter(pastDate)) {
				match = true
			}
			return match
		})
	}
}




// WEBPACK FOOTER //
// ./src/app/services/filterList.service.ts